import React from 'react';

const AWS_Cloud_Computing = () => {
  return (
    <div>
      <h1>AWS_Cloud_Computing</h1>
      <p>This is the AWS_Cloud_Computing component.</p>
    </div>
  );
};

export default AWS_Cloud_Computing;
